import React from 'react';
import { CATEGORY_META } from '@/lib/format';

export function CategoryBadge({ category, testId }) {
  const meta = CATEGORY_META[category] || { label: category, hex: '#64748B' };
  return (
    <span
      data-testid={testId || 'category-badge'}
      className="inline-flex items-center gap-1.5 rounded-full text-[10px] px-2 py-0.5 uppercase tracking-wide font-medium border"
      style={{ color: meta.hex, borderColor: `${meta.hex}55`, background: `${meta.hex}12` }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: meta.hex }} />
      {meta.label}
    </span>
  );
}
